import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f18ba97")

_pushScopeId("data-v-7f18ba97")
const _hoisted_1 = { class: "true-false" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("正确")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("错误")
const _hoisted_5 = {
  key: 1,
  class: "content"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("正确")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("错误")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_radio = _resolveComponent("a-radio")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_radio_group = _resolveComponent("a-radio-group")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.jobView === "preview")
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_a_radio_group, {
            value: _ctx.question,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.question = $event))
          }, {
            default: _withId(() => [
              _createVNode(_component_a_row, null, {
                default: _withId(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withId(() => [
                      _createVNode(_component_a_radio, { value: true }, {
                        default: _withId(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withId(() => [
                      _createVNode(_component_a_radio, { value: false }, {
                        default: _withId(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_a_radio_group, {
            value: _ctx.todoStu,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.todoStu = $event)),
            onChange: _ctx.todoSave,
            disabled: _ctx.jobView === 'see'
          }, {
            default: _withId(() => [
              _createVNode(_component_a_row, null, {
                default: _withId(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withId(() => [
                      _createVNode(_component_a_radio, { value: true }, {
                        default: _withId(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withId(() => [
                      _createVNode(_component_a_radio, { value: false }, {
                        default: _withId(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "onChange", "disabled"])
        ]))
  ]))
})